import PropTypes from 'prop-types'
import { Translate } from 'react-redux-i18n'
import EventEmitter, { SHOW_POPUP_UPGRADE } from '../../../helpers/EventEmitter'
import { CustomLink } from '../../CustomLink'
import { UseTheme } from '../../hooks/useTheme'
import { UseTypeFontSize } from '../../hooks/useTypeFontSize'
import { NumNotification } from '../../numNotification'
import { getStyle } from '../helper'
import { Icon } from '../icon'
import classes from './LinkButton.module.scss'

export const LinkButton = ({
  label,
  hasDropDown,
  isActive,
  isI18n,
  isShowDropdown,
  route,
  style,
  numNotification,
  isLock,
}) => {
  const theme = UseTheme()
  const typeFontSize = UseTypeFontSize()

  const onClick = (e) => {
    if (isLock) {
      e.preventDefault()
      EventEmitter.dispatch(SHOW_POPUP_UPGRADE)
    }
  }

  const renderLabel = () => {
    return isI18n ? <Translate value={label} /> : label
  }

  return (
    <CustomLink
      to={route}
      className={classes.container}
      onClick={onClick}
      style={getStyle(
        {
          color: isActive ? '#0553A5' : '#3A414B',
          textShadow: isActive && '0px 0px 0.3px currentColor',
          fontSize: 14,
          backgroundColor: isActive ? '#F1F3F4' : 'transparent',
          ...style,
        },
        theme,
        typeFontSize,
      )}
    >
      <NumNotification num={numNotification}>{renderLabel()}</NumNotification>
      {hasDropDown && (
        <Icon
          className={isShowDropdown ? 'icon-caret-top' : 'icon-caret-bottom'}
          style={{ fontSize: 8, marginLeft: 10 }}
        />
      )}
    </CustomLink>
  )
}

LinkButton.propTypes = {
  label: PropTypes.string.isRequired,
  hasDropDown: PropTypes.bool,
  isActive: PropTypes.bool,
  isI18n: PropTypes.bool,
  isShowDropdown: PropTypes.bool,
  onClick: PropTypes.func,
  route: PropTypes.string,
  style: PropTypes.object,
  numNotification: PropTypes.number,
  isLock: PropTypes.bool,
}

LinkButton.defaultProps = {
  hasDropDown: false,
  isActive: false,
  isI18n: false,
  isShowDropdown: false,
  onClick: () => {},
  route: '',
  style: {
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 12,
    paddingRight: 12,
  },
  numNotification: 0,
  isLock: false,
}
